import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIconComponent } from '@ng-icons/core';
import { AfraImageComponent } from '../afra-image/afra-image.component';

export interface SharedWorkshopCardRow {
  icon: string;
  title: string;
  value: string;
  badge?: string;
  badgeColor?: string;
}

export interface SharedWorkshopCardAction {
  type: 'button' | 'link';
  label: string;
  class: string;
  link?: string;
  onClick?: (event: Event) => void;
  disabled?: boolean;
}

@Component({
  selector: 'app-shared-workshop-card',
  standalone: true,
  imports: [NgIconComponent, AfraImageComponent],
  templateUrl: './shared-workshop-card.component.html',
  styleUrl: './shared-workshop-card.component.scss',
})
export class SharedWorkshopCardComponent {
  @Input() title!: string;
  @Input() coverImage?: string;
  @Input() description?: string;
  @Input() detailsLink?: string;
  @Input() rows: SharedWorkshopCardRow[] = [];
  @Input() actions: SharedWorkshopCardAction[] = [];
  @Input() isRegisteredAndPending?: boolean = false;
  @Input() isRegisteredAndApproved?: boolean = false;
  @Input() isRegisteredAndRejected?: boolean = false;
  ngOnInit() {
    console.log(this.coverImage);
  }
}
